import { SCRIPTS_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import scriptsTypes from '../constants/scriptsTypes'
import { axios } from '../services'

const reset_script_errors = () => {
  return {
    type: scriptsTypes.reset_errors
  }
}

// INDEX
const scripts_index_request = () => {
  return {
    type: scriptsTypes.index.request
  }
}

const scripts_index_success = (response) => {
  return {
    type: scriptsTypes.index.success,
    payload: response.data
  }
}

const scripts_index_failure = (messages) => {
  return {
    type: scriptsTypes.index.failure,
    payload: messages
  }
}

const scripts_index = (account_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(scripts_index_request())

    // Request
    axios.get(
      formatRoute(SCRIPTS_ROUTES.index, {account_id: account_id})
    ).then( response => {
      // success
      dispatch( scripts_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching scripts."]
      }
      dispatch( scripts_index_failure(errors))
    })
  }
}

// UPDATE
const update_script_request = () => {
  return {
    type: scriptsTypes.update.request
  }
}

const update_script_success = (response) => {
  return {
    type: scriptsTypes.update.success,
    payload: response.data
  }
}

const update_script_failure = (messages) => {
  return {
    type: scriptsTypes.update.failure,
    payload: messages
  }
}

const update_script = (account_id, script_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_script_request())

    // Request
    axios.patch(
      formatRoute(SCRIPTS_ROUTES.update, {account_id: account_id, script_id: script_id}),
      values
    ).then( response => {
      // success
      dispatch( update_script_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating script."]
      }
      dispatch( update_script_failure(errors))
    })
  }
}

// DELETE
const destroy_script_request = () => {
  return {
    type: scriptsTypes.destroy.request
  }
}

const destroy_script_success = (response) => {
  return {
    type: scriptsTypes.destroy.success,
    payload: response.data
  }
}

const destroy_script_failure = (messages) => {
  return {
    type: scriptsTypes.destroy.failure,
    payload: messages
  }
}

const destroy_script = (account_id, script_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(destroy_script_request())

    // Request
    axios.delete(
      formatRoute(SCRIPTS_ROUTES.destroy, {account_id: account_id, script_id: script_id})
    ).then( response => {
      // success
      dispatch( destroy_script_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting script."]
      }
      dispatch( destroy_script_failure(errors))
    })
  }
}

// CREATE
const create_script_request = () => {
  return {
    type: scriptsTypes.create.request
  }
}

const create_script_success = (response) => {
  return {
    type: scriptsTypes.create.success,
    payload: response.data
  }
}

const create_script_failure = (messages) => {
  return {
    type: scriptsTypes.create.failure,
    payload: messages
  }
}

const create_script = (account_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_script_request())

    // Request
    axios.post(
      formatRoute(SCRIPTS_ROUTES.create, {account_id: account_id}),
      values
    ).then( response => {
      // success
      dispatch( create_script_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating script."]
      }
      dispatch( create_script_failure(errors))
    })
  }
}

export {
  reset_script_errors,
  scripts_index,
  update_script,
  destroy_script,
  create_script
}



// WEBPACK FOOTER //
// ./src/js/actions/scriptsActions.js